import React from "react";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";

const useStyles = createUseStyles({
	title: {
		fontFamily: "Inter-Regular",
		color: "#111827",
		fontSize: "12px",
		lineHeight: "16px",
		marginBottom: "4px",
	},
	list: {
		fontFamily: "Inter-Regular",
		color: "#6D7482",
		fontSize: "12px",
		lineHeight: "16px",
		margin: "10px 0",
		"& >div+div": {
			marginTop: "10px",
		},
	},
});

const TariffDetailsList = (props) => {
	const { title, children } = props;
	const classes = useStyles();

	return (
		<div>
			<div className={classes.title}> {title}</div>
			<div className={classes.list}>{children}</div>
		</div>
	);
};

TariffDetailsList.propTypes = {
	title: PropTypes.string,
};
export default TariffDetailsList;
